module.exports = __webpack_public_path__ + "static/media/slider2.9d682e6d.png";